/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

const PROSPECTING_BASE_LINK = '/admin/prospecting'

export function getProspectingCreateLink (params?: Record<string, unknown>) {
  return `${PROSPECTING_BASE_LINK}/create?${stringify(params)}`
}

export function getProspectingLinkTemplate () {
  return `${PROSPECTING_BASE_LINK}/{id}/edit`
}

export function getProspectingListLink (params?: Record<string, unknown>) {
  return `${PROSPECTING_BASE_LINK}?${stringify(params)}`
}
